/**
 *  解析wmsOrderMark
 */
import _ from 'lodash'
/**
 * 根据wmsOrderMark初始化订单的生产行为，如：耗材采集、包裹明细采集、打印通用箱单等等。优先级高于仓内配置的系统参数
 * 具体orderMark每一位含义如下：
 * 第3位 为1代表打印 为0代表不打印
 * ...
 * @param wmsOrderMark
 * @returns orderActions
 */
export const initOrderActions = (wmsOrderMark) => {
  let orderActions = {}
  if (_.isEmpty(wmsOrderMark)) {
    return orderActions
  }
  console.log('wmsOrderMark:' + wmsOrderMark)
  // 是否快递服务订单
  if (wmsOrderMark.charAt(1) === '1') {
    orderActions.expressDelivery = true
  }
  // 第2位：尾程类型 1:快递,2:卡派 3:跨境
  if (wmsOrderMark.charAt(1) === '2') {
    orderActions.truckDelivery = true
  }
  // 第3位：拣选模式 1
  if (wmsOrderMark.charAt(2) === '1') {
    orderActions.labelPickingSwitch = true
  }
  // 第4位 1：件维度打印sscc 2：包裹维度打印sscc 3: 托维度 0：默认不打印
  if (wmsOrderMark.charAt(3) === '1') {
    orderActions.printSsccByOnePiece = true
  } else if (wmsOrderMark.charAt(3) === '2') {
    orderActions.printSsccByPackage = true
  } else if (wmsOrderMark.charAt(3) === '3') {
    orderActions.printSsccByPallet = true
  }

  // 第13位 是否询价订单 0:否 1:是
  if (wmsOrderMark.charAt(12) === '1') {
    orderActions.enquiry = true
  } else {
    orderActions.enquiry = false
  }

  // 第16位 免扫轻量序列号
  if (wmsOrderMark.charAt(15) === '1') {
    orderActions.notScanUniqCode = true
  } else {
    orderActions.notScanUniqCode = false
  }

  // 第19位 订单BC类型
  orderActions.internalOrderTypeStr = wmsOrderMark.charAt(18)

  // 第23位 是否禁止重打包
  if (wmsOrderMark.charAt(22) === '1') {
    orderActions.forbidRepack = true
  } else {
    orderActions.forbidRepack = false
  }

  // 第26位 是否按托call单
  if (wmsOrderMark.charAt(25) === '1') {
    orderActions.isCallByPallet = true
  } else {
    orderActions.isCallByPallet = false
  }

  // 第33位 子不语打印类型  1 FNSKU  2 透明计划码
  orderActions.zibuyuPrintType = wmsOrderMark.charAt(32)

  // 第38位 是否换箱签(away,trafilea 逻辑)
  if (['1', '2', '3'].indexOf(wmsOrderMark.charAt(37)) > -1) {
    orderActions.isChangeBoxLabel = true
  } else {
    orderActions.isChangeBoxLabel = false
  }

  // 第38位 是否是按托换标
  if (wmsOrderMark.charAt(37) === '4') {
    orderActions.isReplacePalletSSCCLabel = true
  } else {
    orderActions.isReplacePalletSSCCLabel = false
  }

  // 第43位 是否是追觅(配载计划 + 打单)
  if (wmsOrderMark.charAt(42) === '1') {
    orderActions.isZhuiMi = true
  } else {
    orderActions.isZhuiMi = false
  }

  // 第43位 配载计划 + 不打单
  if (wmsOrderMark.charAt(42) === '2') {
    orderActions.isLoadingPlanNoPrint = true
  } else {
    orderActions.isLoadingPlanNoPrint = false
  }

  // 第46位 是否是自动拆托
  if (wmsOrderMark.charAt(45) === '1') {
    orderActions.isAutoSplitPallet = true
  } else {
    orderActions.isAutoSplitPallet = false
  }

  // 第49位 是否是正逆一体
  if (wmsOrderMark.charAt(48) === '2') {
    orderActions.forwardAndReverse = true 
  } else {
    orderActions.forwardAndReverse = false
  }

  // 第52位 礼盒标识 0-否 1-是
  if (wmsOrderMark.charAt(51) === '1') {
    orderActions.giftBox = true
  } else {
    orderActions.giftBox = false
  }

  // 第54位 是否是仓内拆单
  if (wmsOrderMark.charAt(53) !== '0') {
    orderActions.splitOrderWithinWarehouse = true
  } else {
    orderActions.splitOrderWithinWarehouse = false
  }

  console.log('解析订单生产行为结果：' + JSON.stringify(orderActions))
  return orderActions
}

// 判断是否是原包耗材
export const isOriginalConsumable = cons => {
  console.log('判断是否原包耗材' + JSON.stringify(cons))
  if(cons && cons.packageId){
    return cons.packageId.split(',').some(item =>{ return item.toLowerCase() === 'original' })
  }
  return false
}
// 包裹是否只有一件商品
export const isOneGoodsInPackage = listPackagingD => {
  console.log(listPackagingD)
  if(!listPackagingD){
    return false
  }
  return listPackagingD && listPackagingD.length === 1 && listPackagingD[0].checkQty === 1;
}

// 判断复核台是否具有某种能力
export const isRecheckDeskHasAbility = (recheckDesk,code) => {
  if(recheckDesk && recheckDesk.equiType && recheckDesk.equiType.indexOf(code) > -1) {
    return true
  }
  return false
}
